import { render, staticRenderFns } from "./ChannelPointsSettings.vue?vue&type=template&id=2d57ba26&scoped=true"
import script from "./ChannelPointsSettings.vue?vue&type=script&lang=js"
export * from "./ChannelPointsSettings.vue?vue&type=script&lang=js"
import style0 from "./ChannelPointsSettings.vue?vue&type=style&index=0&id=2d57ba26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d57ba26",
  null
  
)

export default component.exports